<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { useDisplay } from 'vuetify';

  import { EnumRoutes } from '@/helpers/enums/routes.enum';
  import { useI18 } from '@/plugins';
  import { useAuthStore } from '@/stores/auth.store';
  const { t } = useI18();
  const showBetaBanner = defineModel<boolean>('showBetaBanner');
  const hideBanner = () => {
    showBetaBanner.value = false;
    localStorage.setItem('hideBetaBanner', 'true');
  };
  const { smAndUp } = useDisplay();
  const { user } = storeToRefs(useAuthStore());
</script>

<template>
  <Transition name="slide-fade">
    <v-app-bar
      v-model="showBetaBanner"
      elevation="0"
      :height="smAndUp ? '48' : '80'"
      color="blue-50"
    >
      <div class="position-relative w-100">
        <div
          class="ma-auto text-body-2 text-center text-uppercase text-blue-1 px-8 d-inline-flex ga-1 items-center justify-center w-100 flex-wrap"
        >
          <span class="font-weight-bold">
            {{ t('beta.thisIsBETAVersion') }}
          </span>
          <span v-if="!user" class="position-relative z-1">
            <v-hover>
              <template #default="{ isHovering, props }">
                <router-link
                  v-bind="props"
                  :to="{ name: EnumRoutes.auth.register.name }"
                  class="text-primary cursor-pointer text-uppercase"
                  :class="isHovering ? 'text-decoration-underline' : ''"
                >
                  {{ t('beta.signUp') }}
                </router-link>
              </template>
            </v-hover>
          </span>
          <span v-if="user">
            {{ t('beta.toGetEarlyAccessLogged') }}
          </span>
          <span v-else>
            {{ t('beta.toGetEarlyAccess') }}
          </span>
        </div>
        <div
          class="position-absolute w-100 h-100 d-flex align-center justify-end"
          style="top: 0; left: 0"
        >
          <v-icon
            class="me-2"
            color="primary"
            icon="mdi-close"
            @click="hideBanner"
          />
        </div>
      </div>
    </v-app-bar>
  </Transition>
</template>
<style lang="scss">
  .slide-fade-leave-active,
  .slide-fade-enter-active {
    transition: all 0.5s ease-in-out;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateY(-100%);
    opacity: 0;
  }
</style>
